import ButtonLoader from "@components/ButtonLoader/ButtonLoader";
import { URL } from "@constants/api";
import { Checkbox } from "@mui/material";
import { rootStore } from "@store/Route";
import {
  useElements,
  useStripe,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { AlertError } from "@utils/alert";
import { observer } from "mobx-react-lite";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const AddCreditCard = observer(() => {
  const location = useLocation();
  console.log(location);

  const { outstandingPayment, payment, landing } = rootStore;
  const { totalBill, selectedItemsInvoice } = outstandingPayment;
  const { token } = landing;
  const {
    requestPaymentMethod,
    fetchingRequestPaymentMethod,
    postAttachPaymentMethod,
  } = payment;
  const stripe = useStripe();
  const elements = useElements();
  const [isSaveCreditCard, setIsSaveCreditCard] = useState(false);
  const [isCardFilled, setIsCardFilled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onProceed = useCallback(
    async (event: any) => {
      event.preventDefault();
      if (!stripe || !elements || !requestPaymentMethod?.clientSecret) {
        // Stripe.js has not yet loaded.
        // Make sure to disable form submission until Stripe.js has loaded.
        return;
      }

      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: `${URL}/dashboard/payment/stripe`,
        },
        redirect: "if_required",
      });

      if (
        setupIntent &&
        setupIntent.payment_method === null &&
        typeof setupIntent.payment_method !== "string" &&
        !token
      ) {
        AlertError("Payment Failed", "Your Credit Card was declined!");
        setIsLoading(false);
        return;
      }

      if (error) {
        AlertError(
          "Payment Failed",
          error.message || "Your Credit Card was declined!"
        );
        setIsLoading(false);
        return;
      }

      if (
        setupIntent &&
        typeof setupIntent.payment_method === "string" &&
        token
      ) {
        await postAttachPaymentMethod(
          "stripe",
          token,
          setupIntent.payment_method,
          isSaveCreditCard
        );
        // AlertSuccess('Payment Successful', 'Your Payment was successful!');
      }
      setIsLoading(false);
    },
    [isCardFilled, isSaveCreditCard, requestPaymentMethod?.clientSecret]
  );

  return (
    <form
      onSubmit={(event) => {
        setIsLoading(true);
        onProceed(event);
      }}
    >
      <PaymentElement
        onChange={(CardDetail) => {
          CardDetail.complete && setIsCardFilled(true);
        }}
      />
      <div className="flex flex-col items-start mt-4">
        <div className="flex flex-row items-center">
          <Checkbox
            value={isSaveCreditCard}
            onChange={() => setIsSaveCreditCard(!isSaveCreditCard)}
            style={{
              transform: "scale(1.5)",
            }}
          />
          <h1>Set Credit Card as Default</h1>
        </div>
        <ButtonLoader
          isDisabled={!isCardFilled}
          type="submit"
          className="sm:w-1/2 w-full mt-4"
          isLoading={isLoading}
        >
          Proceed
        </ButtonLoader>
      </div>
    </form>
  );
});

export default AddCreditCard;
